import { render, staticRenderFns } from "./DetailRecomment.vue?vue&type=template&id=f63c4446&scoped=true&"
import script from "./DetailRecomment.vue?vue&type=script&lang=js&"
export * from "./DetailRecomment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f63c4446",
  null
  
)

export default component.exports